<template>
  <div v-loading="loading">
    <div v-if="zxid2 != ''" class="content">
      <el-button type="warning" plain @click="shengcehng">重新生成该报告</el-button>
      <div style="font-size: 15px;display: flex;justify-content:space-between;margin: 15px 0;">
        <span>报告编号: {{ serialNo }}</span>
        <span> </span>
      </div>

      <div class="diyihang">
        状态:<span class="lanse">{{ remark }}</span>
      </div>

      <div style="display: flex;">
        <div class="num">


          <div class="card" v-for="(item, index) in list" :key="index">
            {{ item.value }}
            :
            <span>{{ listdata[item.name] }} </span>
          </div>


        </div>
      </div>

    </div>
    <div v-else class="bgelse">
      <div class="tishi">提示：请生成报告后再查看该报告！</div>
      <div class="baogao">征信报告没有生成</div>
      <div class="shhengcheng">
        <el-button type="warning" plain @click="shengcehng"> 
          <span v-if="hrzx_authorization">生成该报告</span>
          <span v-else>生成静默签</span>
         </el-button>
      </div>
    </div>

  </div>
</template>

<script>
import FengkongApi from "@/api/fengkong.js";
import OrderApi from "@/api/order.js";
export default {
  props: ["order_id", "user_id", "list", "zxid2"],
  data() {
    return {
      loading: false,
      zfzxData2: "",
      listdata: "",
      serialNo: "",
      remark: "",
      hrzx_authorization: ""

    };
  },
  created() {
    this.getdetail();

    // console.log("list", this.list);
    console.log("zxid2", this.zxid2);

    if (this.zxid2) {
      var data = JSON.parse(this.zxid2);
      this.remark = data.data.remark;
      this.serialNo = data.data.serialNo;
      let item = JSON.parse(data.data.report);
      let newboj = {};

      for (let i = 0; i < item.length; i++) {
        // console.log(item[i].name,item[i].value);
        newboj[item[i].name] = (item[i].value);
      }
      // console.log("newboj",newboj);
      this.listdata = newboj;
    }
  },
  methods: {
    // 生成静默签
    getdetail() {
      OrderApi.orderdetail({ order_id: this.order_id, }, true)
        .then(res => {
          this.hrzx_authorization = res.data.detail.hrzx_authorization;
          self.$message({
              message: '下载成功',
              type: 'success'
            });
        })
        .catch(error => {
          self.loading = false;
        });
    },
    // 生成报告
    shengcehng() {
      let self = this;
      self.loading = true;

      if (self.hrzx_authorization) {
        let param = {
          order_id: self.order_id,
          user_id: self.user_id
        }
        FengkongApi.trade(param, true)
          .then(res => {
            console.log("成功", res);
            self.serialNo = res.data.res2.data.serialNo;
            self.remark = res.data.res2.data.remark;
            self.zxid2 = res.data.res2.data;

            let item = JSON.parse(res.data.res2.data.report);  //res.data.res2.data.report;
            let newboj = {};
            for (let i = 0; i < item.length; i++) {
              // console.log(item[i].name,item[i].value);
              newboj[item[i].name] = (item[i].value);
            }
            // console.log("newboj",newboj);
            self.listdata = newboj;

            self.$message({
              message: '生成成功',
              type: 'success'
            });
            self.$parent.getParams();
            self.loading = false;

          })
          .catch(error => {
            self.loading = false;
          });
      } else {
        FengkongApi.hrzxqs({ order_id: self.order_id, }, true)
          .then(res => {
            self.getdetail();
            self.loading = false;
          })
          .catch(error => {
            self.loading = false;
          });
      }




    }

  },
  filters: {
    // 过滤器
    formatDate(create_time1) {
      let date = new Date(create_time1);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      // return y + '-' + MM + '-' + d; //年月日
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s; //年月日时分秒
    },
  },
};
</script>
  
<style>
.num {

  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;

}

.num .card {
  width: 33%;
  padding: 5px;
  border: 1px solid #EFEFEF;
  font-size: 15px;
}

.num .card span {
  font-weight: bold;
}

.content {
  width: 100%;
  padding: 25px 33px 46px;
  background-color: #f5f6f8;
}

.diyihang {
  text-align: center;
  margin: 20px;
  font-size: 20px;
  width: 100%;
}

.lanse {
  color: #1890ff;
}

.biaoge {
  border-collapse: collapse;
  width: 100%;
}

.biaoge1 {
  text-align: center;
  border-collapse: collapse;
  width: 100%;
  margin-top: 20px;
}
</style>
  


// WEBPACK FOOTER //
// src/views/fengkong/operation/detail7 copy.vue